import { ExportPayloadSection } from '../../types';

const MAX_SHEET_NAME_LENGTH = 31;
const INVALID_SHEET_NAME_CHARS = /[[\]:*?/\\]/g;

const resolveXlsxSheetName = (sections: ExportPayloadSection[]): string => {
  const label = sections[0]?.label ?? '';
  const sanitized = label
    .replace(INVALID_SHEET_NAME_CHARS, '')
    .trim()
    .slice(0, MAX_SHEET_NAME_LENGTH);

  return sanitized || 'Export';
};

export default resolveXlsxSheetName;
